import { Pipe, PipeTransform } from '@angular/core';
import { parse, format } from 'date-fns';
import { enUS } from 'date-fns/locale';

import { CommonConstant } from 'src/app/constants';
import { DeliveryType, MealDeliveryAreaTiming } from 'src/app/models';

@Pipe({
  name: 'posMealDeliveryAreaTimingDisplay'
})
export class MealDeliveryAreaTimingDisplayPipe implements PipeTransform {
  constructor() {}

  transform(
    timing: MealDeliveryAreaTiming,
    langCode: string,
    deliveryType: DeliveryType
  ): string {
    const locale = CommonConstant.LOCALE_MAPPER[langCode] || enUS;
    const fromDateFormatted = format(
      parse(`${timing.from_hr}:${timing.from_min}`, 'H:m', new Date()),
      'p',
      {
        locale
      }
    );

    const toDateFormatted = format(
      parse(`${timing.to_hr}:${timing.to_min}`, 'H:m', new Date()),
      'p',
      {
        locale
      }
    );

    if (deliveryType === DeliveryType.PICK_UP) {
      return fromDateFormatted;
    }

    return `${fromDateFormatted} - ${toDateFormatted}`;
  }
}
